/** Additional English strings — merged into en locale */
const enExt = {
  reviewHub: {
    title: "Review Hub",
    subtitle: "Reply, prioritize critical reviews, and request removals — all in one place.",
    syncReviews: "Sync Reviews",
    syncing: "Syncing…",
    noProfile: "No connected profile",
    noProfileHint: "Connect Google Business to manage reviews in one place.",
    connectPlatform: "Connect Platform",
    profile: "Profile",
    loadError: "Reviews could not be loaded.",
    syncSuccess: "Sync completed successfully.",
    syncFailed: "Sync failed.",
    replyFailed: "Failed to send reply.",
    deselectAll: "Deselect all",
    selectAllVisible: "Select all visible",
    noCritical: "No critical reviews",
    allCaughtUp: "All caught up",
    everyReviewReplied: "Every review has a response.",
    nothingHurtingRating: "Nothing is hurting your rating right now.",
    noReviewsToShow: "No reviews to show.",
    viewDeletionCases: "View deletion cases",
    previous: "Previous",
    next: "Next",
    pageOf: "Page {{page}} of {{total}}",
    caseSubmitted: "Case {{caseId}} submitted successfully.",
    justNow: "Just now",
    hoursAgo: "{{hours}}h ago",
    oneDayAgo: "1 day ago",
    daysAgo: "{{days}} days ago",
    highRisk: "High Risk",
    needsReply: "Needs Reply",
    criticalHint: "Consider replying first, or request removal if this violates platform policies.",
    noReviewText: "No review text.",
    seeMore: "See more",
    seeLess: "See less",
    yourResponse: "Your Response",
    replyQueued: "Reply queued — sending to Google…",
    jamedaReplyUnavailable: "Replies on Jameda coming soon",
    sendResponse: "Send Response",
    sending: "Sending…",
    selectForRemoval: "Select for removal",
    deselectForRemoval: "Deselect for removal",
    allVisibleInDeletionCase:
      "All visible critical reviews are already in a deletion case.",
    caseSuccessLink: "View deletion cases",
  },
  metrics: {
    reviewsTotal: "Total",
    reviewsTotalHint: "All imported reviews",
    reviewsAverage: "Average",
    reviewsAverageHint: "Current profile average",
    reviewsNewToday: "New today",
    reviewsNewTodayHint: "Newly synced today",
    reviewsCritical: "Critical (≤3★)",
    reviewsCriticalHint: "Needs attention",
    casesTotal: "Total Cases",
    casesTotalHint: "All submitted requests",
    casesPending: "Pending",
    casesPendingHint: "Awaiting initial review",
    casesInProgress: "In Progress",
    casesInProgressHint: "Legal review stage",
    casesCompleted: "Completed",
    casesCompletedHint: "Successfully removed",
    casesRejected: "Rejected",
    casesRejectedHint: "Appeal possible",
    casesNewThisMonth: "+{{count}} this month",
  },
  billing: {
    title: "Plans & Billing",
    statusLabel: "Status: {{status}}",
    starter: "Starter",
    freeTier: "Free Tier",
    currentPlan: "Current Plan",
    mostPopular: "Most Popular",
    professional: "Premium",
    basicPlan: "Basic",
    premiumPlan: "Premium",
    basicTagline: "Everything from your free trial — without a time limit",
    chooseBasic: "Choose Basic",
    upgradeProfessional: "Upgrade to Premium",
    enterprise: "Enterprise",
    contactSales: "Contact Sales",
    planComparison: "Plan Comparison",
    ctaTitle: "Ready to secure your global reputation?",
    ctaSubtitle: "Upgrade to Premium for monthly deletions and priority support.",
    goToPayment: "Go to payment",
    activeCases: "Active Cases",
    startNewCase: "Start a new deletion case",
    selectReviews: "Select reviews",
    volumePricing: "Volume-based pricing",
    perEach: "/ea",
    freeTierButton: "Free Tier",
    monthly: "/month",
    billedMonthly: "Billed monthly",
    featureBillingModel: "Billing Model",
    featureReviewSelection: "Review Selection",
    featureIncludedDeletions: "Included Deletions",
    featurePricePerReview: "Price per Review",
    featureSupportLevel: "Support Level",
    featureReporting: "Reporting",
    freeBilling: "Pay-per-bulk deletion",
    proBilling: "Fixed monthly subscription",
    entBilling: "Individual agreement",
    freeSelection: "Bulk deletion cases",
    proSelection: "Flexible — submit as needed",
    entSelection: "Flexible — all locations",
    freeIncluded: "None — priced per review",
    proIncluded: "2 Free cases per month",
    entIncluded: "Custom quota",
    freePrice: "Volume-based (from €79)",
    proPrice: "€79 (after included)",
    entPrice: "On request",
    freeSupport: "Documentation only",
    proSupport: "24h Priority support",
    entSupport: "Dedicated contact person",
    freeReporting: "Basic monthly summary",
    proReporting: "Real-time status updates",
    entReporting: "Real-time + custom reports",
    freeFeature1: "Basic review monitoring",
    freeFeature2: "No included monthly deletions",
    freeFeature3: "Manual case submission only",
    proFeature1: "2 Free deletions per month",
    proFeature2: "Reduced rate: €79 / case",
    proFeature3: "Advanced platform sync",
    proFeature4: "Priority support access",
    proFeature5:
      "Select negative reviews with one click and trigger the deletion process directly",
    proFeature6: "Reply to reviews right from the dashboard",
    proFeature7:
      "Integrated review monitoring with alerts for new reviews (cross-platform: Google, GoLocal, Kununu & more)",
    proFeature8:
      "Automated collection of positive reviews via an email feedback system",
    proFeature9: "Business Network (connect with companies from our network)",
    entFeature1: "Connect unlimited locations per platform (Google, Jameda, etc.)",
    entFeature2: "Everything in the Premium plan included",
    entFeature3: "Individual terms & deletion quotas",
    entFeature4: "Dedicated contact person & priority support",
    scale: "Scale",
    enterprisePlan: "Enterprise",
    individualPrice: "Custom",
    enterpriseTagline:
      "For chains, groups and agencies with multiple locations — pricing on request.",
    oneLocation: "1 location per platform connectable (Google, Jameda, etc.)",
    oneLocationShort: "1 per platform",
    unlimitedLocations: "Unlimited — per platform",
    featureLocations: "Connected locations",
    trialNoteTitle: "3-day free trial — with every feature",
    trialNote:
      "During the trial you can connect unlimited locations per platform and use all features. After 3 days, simply pick the plan that fits.",
    band1: "1–5 reviews",
    band2: "6–10 reviews",
    band3: "11+ reviews",
    growth: "Growth",
    architect: "Architect",
    custom: "Custom",
    proTagline: "Optimal for scaling businesses",
    entTagline: "High-volume corporate solution",
    comparisonDesc: "Detailed feature breakdown for enterprise decision makers.",
    featureColumn: "Feature",
    paidDesc:
      "Your Premium plan includes monthly deletion credits, reduced per-case rates, and priority support.",
    unpaidDesc:
      "Choose Basic (€79/month) to keep your trial features, or Premium (€179/month) for lower per-review rates, monthly included deletions, and advanced reporting.",
    includedOf: "/ {{count}} included",
    freeDeletionsRemaining:
      "You have {{count}} free deletion(s) left in your current 30-day period. Additional removals are estimated at {{price}} per review (invoiced manually).",
  },
  subscription: {
    professionalBenefitsTitle: "Professional plan benefits",
    freeRemainingBanner: "{{remaining}} of {{allowance}} free review deletions left",
    freeUsedThisPeriod: "{{count}} already used this period",
    periodEnds: "Current period ends {{date}} — allowance renews after that.",
    resetsOn: "Allowance renews on {{date}}",
  },
  payment: {
    backToDashboard: "Back to dashboard",
    secureCheckout: "Secure Checkout",
    checkout: "Checkout",
    paymentHistory: "Payment history",
    noPayments: "No payments yet",
    paymentMethod: "Payment method",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    afterPaymentHint: "After payment, return to reviews to submit your deletion case.",
    processing: "Processing…",
    orderSummary: "ORDER SUMMARY",
    included: "Included",
    totalDue: "Total due",
    billedMonthlyCancel:
      "Automatically renews each billing cycle until you cancel.",
    secureSsl: "Secure checkout — SSL encrypted",
    vatInvoice: "VAT invoice available after payment",
    needAssistance: "Need assistance?",
    contactSupport: "Contact Support",
    cardholderRequired: "Cardholder name is required.",
    cardholderName: "CARDHOLDER NAME",
    cardholderPlaceholder: "e.g. Johnathan Doe",
    cardNumberInvalid: "Enter a valid card number.",
    expiryDate: "EXPIRY DATE",
    expiryFormat: "Use MM/YY format.",
    cardEncrypted: "Your card details are encrypted at the source and never stored on our servers.",
    payWithCard: "Pay {{amount}} with card",
    paypalEmailRequired: "Enter the PayPal email linked to your account.",
    paypalRedirect: "After confirming, you will be redirected to PayPal to complete payment.",
    paypalEmail: "PAYPAL EMAIL",
    continuePaypal: "Continue to PayPal — {{amount}}",
    sepaNameRequired: "Account holder name is required.",
    sepaIbanInvalid: "Enter a valid IBAN (no spaces).",
    sepaMandateRequired: "You must authorize the SEPA direct debit mandate.",
    sepaHint: "Pay from your EU bank account via SEPA direct debit.",
    sepaBicHint: "Required for some non-German accounts.",
    sepaMandate: "I authorize a SEPA direct debit mandate for {{amount}} to ReviewLytics GmbH.",
    paySepa: "Pay {{amount}} via SEPA",
    paymentSuccessful: "Payment Successful",
    paymentSuccessBody:
      "Your Professional plan is active. Subscription renews automatically each month. Redirecting…",
    methodCard: "Credit card",
    methodCardDesc: "Visa, Mastercard, Amex",
    methodPaypal: "PayPal",
    methodPaypalDesc: "Pay with balance or bank",
    methodSepa: "SEPA debit",
    methodSepaDesc: "EU direct bank transfer",
    subscriberTitle: "Premium plan",
    basicTitle: "Basic plan",
    basicSubtitle: "€79/month — billed monthly with automatic renewal",
    basicPlanLine: "Basic plan (monthly)",
    subscriberSubtitle: "€179/month — billed monthly with automatic renewal",
    subscriberPlanLine: "Professional plan (monthly)",
    includedDeletionsLine: "Included review deletions",
    deletionsAllowance: "{{count}} deletions per month allowance",
    deletionPaymentTitle: "Review deletion payment",
    deletionBulk: "{{count}} review(s) — bulk deletion case",
    deletionLine: "Review deletion — {{tier}}",
    deletionLineGeneric: "Review deletion (bulk case)",
    deletionSubtitle: "{{count}} review(s) in this submission",
    checkoutSubtitle:
      "Subscribe to your chosen plan (auto-renewing monthly). Review deletion and other manual services are invoiced separately.",
    subscriptionOnlyNote:
      "This checkout covers your monthly subscription only. Deletion case charges are estimated in the app and invoiced manually outside the platform.",
    stripeCheckoutTitle: "Subscribe with Stripe",
    stripeCheckoutDesc:
      "You will complete payment on Stripe’s secure checkout page. We never store your card or bank details.",
    stripeRedirectNote:
      "Click below to open Stripe Checkout. Card and SEPA direct debit are available depending on your region.",
    stripeRenewalNote:
      "{{amount}} per month — automatically renews until you cancel your subscription.",
    stripeMethodsNote: "Pay by credit card or SEPA direct debit (via Stripe).",
    stripeSecureNote: "PCI-compliant checkout — payment details stay with Stripe.",
    subscribeNow: "Subscribe — {{amount}}/month",
    stripePowered: "Payments processed securely by Stripe.",
    paymentNotConfigured: "Online checkout is being set up",
    paymentNotConfiguredHint:
      "Stripe is not connected yet. Please contact support or try again once your account manager confirms payment is live.",
    alreadySubscribed: "You’re on the Professional plan",
    alreadySubscribedHint:
      "Your subscription is active and renews automatically each month.",
    manageBilling: "View billing details",
    checkoutCancelled: "Checkout was cancelled. You can try again when ready.",
    verifyPaymentFailed: "We could not confirm your payment. Please contact support if you were charged.",
    verifyingPayment: "Confirming your payment…",
    checkoutStartFailed: "Could not start checkout. Please try again or contact support.",
    completedPayments: "Completed payments will appear here.",
    goToCheckout: "Go to checkout",
    allEncrypted: "All payment options are fully encrypted and secure.",
    support24: "Our enterprise support team is available 24/7 for checkout issues.",
    footerCopyright:
      "© 2026 ReviewLytics. Secure Checkout.",
    afterPaymentReturn: "After payment, return to",
    afterPaymentSubmit: "to submit your deletion case.",
    cardNumber: "CARD NUMBER",
    cvc: "CVC",
    securityCodeRequired: "Enter the security code.",
    accountHolder: "ACCOUNT HOLDER",
    accountHolderPlaceholder: "Company or personal name",
    iban: "IBAN",
    bicOptional: "BIC (OPTIONAL)",
    sepaMandateRecurring: "each month until I cancel my subscription.",
    sepaMandateOneTime: "for this one-time payment.",
    sepaMandateRefund: "I can request a refund within 8 weeks per SEPA rules.",
    methodAria: "Payment method",
    paypalPlaceholder: "you@example.com",
  },
  pricingPanel: {
    livePricing: "Live pricing",
    tierProgress: "Tier progress",
    pricingByStatus: "Pricing is set by your account status.",
    successRate: "Current success rate: 93%",
    freeTier: "Free Tier",
    subscriber: "Subscriber",
    selectedReviews: "Selected reviews",
    pricePerReview: "Price per review",
    estimatedTotalThisCase: "Estimated total (this case)",
    totalThisCase: "Total (this case)",
    continueToCase: "Continue to case details",
    manualInvoicingNote:
      "The stated deletion costs are for orientation only. Only successfully removed reviews are charged. You will receive the invoice separately by email once the deletions are complete.",
    clearSelection: "Clear selection",
    freeRemaining: "{{count}} free deletion(s) remaining",
    estimatedTotal: "Estimated total",
    activePackage: "Active package:",
    savingsVs: "You save {{amount}} vs. the €129 tier on this batch",
    bulkNote:
      "All selected reviews are submitted together in one bulk case. Pricing updates as you add reviews.",
    freeThisMonth: "Free this month (left)",
    freeAppliedLabel: "Free applied to selection",
    paidReviews: "Paid reviews",
    perPaidReview: "Per paid review",
    caseTotal: "Case total",
    planBilled: "Plan: {{amount}}/mo (subscription billed separately)",
    submissionSummary:
      "{{freeApplied}} free + {{paidCount}} paid = {{total}} for this submission",
    freeAppliedHighlight: "{{count}} review(s) included free in this case",
    freeAppliedDetail:
      "Applied automatically from your Professional allowance (2 free deletions every 30 days).",
    noFreeRemaining:
      "No free deletions left in this 30-day period. Additional reviews are estimated at the paid rate.",
    subscriberPlan: "Subscriber plan",
    billingPlanAria: "Billing plan",
    livePricingAria: "Live pricing",
    ratingImpact: "Rating impact",
    currentRating: "Current",
    afterDeletion: "After deletion",
    ratingImpactHint: "Select reviews to preview your new rating.",
    ratingImpactBasedOn: "Based on {{count}} reviews on this profile.",
  },
  documentation: {
    featured: "Featured",
    minRead: "{{minutes}} min read",
    defamationDesc: "Identify reviews with false factual claims that may qualify for removal.",
    replyDesc: "Professional and friendly response templates for every review type.",
    deletionDesc: "Step-by-step guide from review selection to legal resolution.",
    googlePoliciesDesc: "Platform rules for spam, conflicts of interest, and prohibited content.",
    ratingImpactDesc: "How critical reviews affect your average and profile performance.",
    reviewCritical: "Review critical items",
    articleDefamation: "Defamation Guide",
    articleReply: "Reply Best Practices",
    articleDeletion: "Deletion Case Process",
    articleGoogle: "Google Review Policies",
    articleRating: "Understanding Rating Impact",
  },
  signup: {
    stepPersonal: "Personal details",
    stepCompany: "Company details",
    journeyTitle: "Start your journey",
    journeySubtitle: "Create your account in two simple steps.",
    fullNameLabel: "Full name",
    nextCompany: "Next: Company details",
    haveAccount: "Already have an account?",
    completeRegistration: "Complete registration",
    consentRegistration: "By registering you agree to our",
    processingTitle: "Creating your profile…",
    processingSubtitle: "Verifying your credentials…",
    systemIntegrity: "SYSTEM INTEGRITY",
    stepEmail: "VERIFYING EMAIL",
    stepSecurity: "GENERATING SECURITY KEYS",
    stepSetup: "COMPLETING ACCOUNT SETUP",
    successTitle: "Your account is ready!",
    successSubtitle: "Welcome to the future of digital presence management.",
    adminRegisterTitle: "Register new user",
    adminRegisterSubtitle: "Same flow as public registration — admin creates the account.",
    userRegistered: "{{name}} ({{email}}) has been registered.",
    registering: "Registering…",
  },
  adminHome: {
    title: "Admin Dashboard",
    subtitle: "Overview of all deletion cases, users, and platform activity.",
    overview: "Platform overview",
    platformAdmin: "Platform Admin",
    analyticsTitle: "Deletion Cases — Analytics",
    viewAllCases: "View all cases",
    viewAllUsers: "View all users",
    manageCases: "Manage deletion cases",
    manageCasesDesc: "Review requests, mark outcomes, and close cases.",
    usersCard: "Users",
    usersDesc: "Register accounts, roles, and impersonation.",
    actionCases: "Manage cases",
    actionCasesDesc: "Review deletion requests and update outcomes.",
    actionUsers: "User management",
    actionUsersDesc: "Search accounts, change roles, impersonate clients.",
    actionAlerts: "Email alerts",
    actionAlertsDesc: "Configure admin notifications for platform events.",
    actionDocs: "Operations docs",
    actionDocsDesc: "Internal guides for case handling and impersonation.",
    activeCasesLabel: "Active cases",
    activeCasesHint: "Pending and in-progress deletion requests",
    workflowTitle: "Recommended admin workflow",
    workflow1: "Monitor new deletion cases and assign outcomes per review.",
    workflow2: "Use impersonation to support clients in their dashboard when needed.",
    workflow3: "Keep user roles and account status aligned with billing.",
    opsGuideTitle: "Operations guide",
    opsGuideDesc: "Internal playbooks for case handling, impersonation, and moderation.",
    readOpsDocs: "Read operations docs",
  },
  adminCases: {
    title: "Deletion Cases — Management",
    outcomeHint: "Please mark each review as Removed or Removal failed before closing the case.",
    loading: "Loading requests…",
    noMatches: "No requests match these filters",
    totalRequests: "{{count}} request(s) total",
    searchPlaceholder: "Case ID, name, email, justification…",
  },
  adminReviews: {
    title: "Reviews (Admin)",
    subtitle: "Cross-company review moderation and oversight.",
    companiesTracked: "Companies tracked",
    pendingModeration: "Pending moderation",
    flaggedWeek: "Flagged this week",
    toolsTitle: "Admin review tools",
    globalSearch: "Global review search",
    searchPlaceholder: "Author, review text, company, location…",
    loading: "Loading reviews…",
    noReviews: "No reviews found",
    noReviewsHint: "Try adjusting filters or search terms.",
    totalReviews: "{{count}} review(s) total",
    unknownCompany: "Unknown company",
    openClientHub: "Open client hub",
  },
  deletionCaseUi: {
    noReviewText: "No review text",
    included: "Incl.",
    reviewNumber: "Review #{{id}}",
    reviewAria: "Review {{id}} by {{author}}",
    pricingOverview: "Pricing overview",
    caseTotal: "Case total",
    package: "Package",
    perReview: "Per review",
    free: "Free",
    estimateHint: "Estimate based on current package and selection.",
    caseSum: "Case sum",
    noReviews: "No reviews",
    anonymous: "Anonymous",
    moreReviews: "+{{count}} more",
    viewAll: "View all",
    reviewsForDeletion: "Reviews for deletion",
    reviewsInCase: "{{count}} review(s) in this case",
    noLinkedReviews: "No reviews linked to this case.",
    deletionOutcome: "Deletion outcome",
    justification: "Justification",
    lastUpdated: "Last updated: {{date}}",
    estimatedBeforeSave: "Estimated (before save)",
    deletedCount: "{{count}} removed",
    notDeletedCount: "{{count}} removal failed",
    pendingCount: "{{count}} pending",
    partiallyComplete: "Partially complete",
    outcomePending: "Pending",
    outcomeDeleted: "Removed",
    outcomeNotDeleted: "Removal failed",
  },
  replies: {
    professional: "Professional",
    friendly: "Friendly",
    serviceApology: "Service apology",
    waitTime: "Wait time issue",
    thankPositive: "Thank positive review",
    inviteOffline: "Invite offline discussion",
    billingClarify: "Billing clarification",
  },
  authUi: {
    brandTagline: "Elevate your digital presence with precision.",
    gdprCompliant: "GDPR compliant",
    sslSecure: "SSL secure",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    consentSuffix: ".",
    consentBetween: "and the",
  },
  platformsLoading: {
    stepAuth: "Auth",
    stepAccounts: "Accounts",
    stepLocations: "Locations",
    loadingLocations: "Loading locations",
    establishingConnection: "Establishing connection",
  },
  adminOutcome: {
    ariaLabel: "Deletion status per review",
    title: "Deletion status per review",
    hint: "Mark each review as removed or removal failed before closing the case.",
    markAllDeleted: "Mark all removed",
    markAllNotDeleted: "Mark all removal failed",
    resetAll: "Reset all",
    statusFor: "Status for {{author}}",
    preview: "Preview:",
    saveStatus: "Save status",
    openPlatform: "Open on {{platform}}",
    openListing: "Open platform listing",
    platformListings: "Platform listings",
  },
  adminStats: {
    total: "Total",
    totalHint: "All deletion cases",
    new: "New",
    newHint: "Last 7 days",
    pending: "Pending",
    pendingHint: "Awaiting processing",
    inProgress: "In Progress",
    inProgressHint: "Started & legal action",
    completed: "Completed",
    completedHint: "Successfully resolved",
    rejected: "Rejected",
    rejectedHint: "Declined cases",
    newCasesWeek: "{{count}} new cases in the last 7 days",
  },
  adminUserStats: {
    sectionTitle: "Users — Overview",
    total: "Total users",
    totalHint: "All registered accounts",
    new: "New this week",
    newHint: "Joined in the last 7 days",
    paid: "Professional accounts",
    paidHint: "Active Professional subscriptions",
    unpaid: "Free Tier accounts",
    unpaidHint: "Free Tier clients",
  },
  adminEmailAlerts: {
    title: "Admin Email Alerts",
    subtitle: "Choose which platform events should notify your admin team.",
    newCase: "New deletion case",
    newCaseHint: "When a client submits a new deletion request.",
    newUser: "New user registration",
    newUserHint: "When a new account is created on the platform.",
    criticalReview: "Critical review flagged",
    criticalReviewHint: "When a 1–2 star review is synced for any company.",
    caseStatus: "Case status changes",
    caseStatusHint: "When a deletion case moves to a new processing stage.",
    weeklyDigest: "Weekly platform digest",
    weeklyDigestHint: "Summary of cases, users, and review activity.",
  },
  adminSettings: {
    title: "Admin Settings",
    subtitle: "Configure your admin workspace preferences and defaults.",
    workspaceTitle: "Admin workspace",
    emailNotifications: "Platform email notifications",
    emailNotificationsHint: "Receive admin alerts for critical platform events.",
    compactTables: "Compact table layout",
    compactTablesHint: "Show denser rows in user and case tables.",
    showCasePricing: "Show case pricing columns",
    showCasePricingHint: "Display billing amounts in the deletion cases table.",
    confirmImpersonation: "Confirm before impersonation",
    confirmImpersonationHint: "Ask for confirmation before signing in as a client.",
    quickLinks: "Quick links",
    opsDocs: "Operations documentation",
    emailAlerts: "Email alerts",
    userManagement: "User management",
  },
  adminDocs: {
    title: "Operations Documentation",
    subtitle: "Internal guides for platform administrators.",
    featured: "Featured guide",
    impersonationTitle: "Client impersonation",
    impersonationDesc:
      "Sign in as a client to manage their review hub, replies, and platform connections. Your admin session is preserved in the background.",
    openUsers: "Open user list",
    caseOutcomesTitle: "Marking case outcomes",
    caseOutcomesDesc:
      "Set each review as removed or removal failed before closing a case as completed.",
    userRolesTitle: "Roles & account status",
    userRolesDesc:
      "Superusers can promote users to admin or set client accounts to Free Tier or Professional.",
    reviewModerationTitle: "Cross-company review moderation",
    reviewModerationDesc:
      "Browse reviews across all companies, filter by urgency, and impersonate to reply.",
    deletionWorkflowTitle: "Deletion case workflow",
    deletionWorkflowDesc:
      "Process cases from initiated through legal action to completed or rejected.",
  },
  adminUserDetail: {
    backToUsers: "Back to users",
    notFound: "User not found",
    registered: "Registered {{date}}",
    cases: "Deletion cases",
    reviews: "Company reviews",
    view: "View",
    noCompany: "No company linked",
    trialSection: "Free trial",
    trialEnds: "Trial ends {{date}}",
    trialExpiredOn: "Trial ended {{date}}",
    trialNotSet: "No trial end date set",
    trialDaysLeft: "{{count}} day(s) remaining",
    extendTrial: "Extend free trial",
    extendTrialHint:
      "Add free days for this client. If the trial already ended, it will be reopened from today.",
    daysLabel: "Days to add",
    extendButton: "Extend by {{days}} days",
    extending: "Extending…",
    extendSuccess: "Trial extended successfully.",
    customDays: "Custom",
    teamSection: "Team members",
    teamSectionHint:
      "Sub-users of this account. Open a member to view their activity and impersonate them.",
    teamEmpty: "No team members on this account yet.",
    teamMemberBadge: "Sub-user",
    ownerBadge: "Account owner",
    ownerOf: "Sub-user of {{name}}",
    viewOwner: "View account owner",
    openMember: "Open",
    membersCount: "{{count}} team member(s)",
    joined: "Joined {{date}}",
  },
  adminUserActivity: {
    title: "Activity",
    subtitle: "Sign-ins, security events, and product actions for this account.",
    filterAll: "All",
    filterAuth: "Auth",
    filterProduct: "Product",
    loading: "Loading activity…",
    loadingMore: "Loading…",
    loadMore: "Load more",
    empty: "No activity recorded for this user yet.",
    ip: "IP",
    actor: "By",
    failed: "Failed",
    platform: "Platform",
    location: "Location",
    case: "Case",
    events: {
      login_success: "Login success",
      login_failed: "Login failed",
      login_2fa_challenge: "2FA challenge",
      login_2fa_success: "2FA login success",
      login_2fa_failed: "2FA login failed",
      logout: "Logout",
      registered: "Account registered",
      impersonation_started: "Impersonation started",
      impersonation_stopped: "Impersonation stopped",
      case_submitted: "Deletion case submitted",
      ticket_created: "Support ticket created",
      ticket_replied: "Support ticket reply",
      review_replied: "Review reply",
      google_connected: "Google connected",
      google_disconnected: "Google disconnected",
      jameda_connected: "Jameda connected",
      jameda_disconnected: "Jameda disconnected",
      notification_prefs_updated: "Email alerts updated",
      role_changed: "Role changed",
      account_status_changed: "Account status changed",
      trial_extended: "Trial extended",
      two_factor_enabled: "2FA enabled",
      two_factor_disabled: "2FA disabled",
    },
  },
  adminTable: {
    caseId: "Case ID",
    user: "User",
    email: "Email",
    company: "Company",
    package: "Package",
    violation: "Violation",
    reviews: "Reviews",
    amount: "Amount",
    status: "Status",
    created: "Created",
    actions: "Actions",
    name: "Name",
    registered: "Registered",
    registerUser: "Register user",
    usersSubtitleExtended:
      "All registered accounts with search and filters. Admins can sign in as a client (impersonation) — the admin session stays in the background. Other administrators only as superuser.",
    clientRole: "client",
    searchLabel: "Search",
    filterSummarySearch: "Search: \"{{query}}\"",
    noUsersFound: "No users found.",
    superLabel: "Super",
    roleFor: "Role for {{name}}",
    accountFor: "Account status for {{name}}",
    packageSubscriber: "Professional",
    packageFree: "Free Tier",
    action: "Action",
    expandDetails: "Details",
    collapseDetails: "Collapse",
    statusForCase: "Status for {{caseId}}",
    manage: "Manage",
    submittedReviews: "Submitted Reviews ({{count}})",
    bulkSelect: "Bulk Select",
    exportDetails: "Export Details",
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "{{count}} days ago",
  },
  dashboardBento: {
    adminHeroSubtitle:
      "System-wide oversight for reputation recovery operations. Monitor user growth, active case progression, and operational efficiency across the platform.",
    clientHeroSubtitle:
      "Monitor reviews, respond to critical feedback, and track deletion cases from one command center.",
    newThisWeekShort: "{{count}} new this week",
    newTodayShort: "{{count}} new today",
    criticalShort: "{{count}} critical",
    peak: "Peak",
    adminNewFootnote: "New registrations in the last 7 days",
    userOverview: "User Overview",
    accountOverview: "Account Overview",
    growthAlert: "Growth alert",
    growthAlertMsg: "{{count}} new user(s) joined this week.",
    last30Days: "Last 30 days",
    caseDistribution: "Case distribution",
    sentimentTrend: "Sentiment distribution",
    chartEmpty: "No data yet for this chart.",
    reviewCaseAnalytics: "Reviews & Cases — Analytics",
    resources: "Resources",
    planStatus: "Plan status",
    platformsConnected: "Platforms connected",
    sentimentSummary: "{{positive}}% positive · {{negative}}% critical",
    adminResource1: "Recommended workflow for GDPR requests",
    adminResource2: "Enterprise user & role management",
    adminResource3: "Deletion case SLA dashboard",
    clientResource3: "Open Review Hub for all reviews",
  },
  support: {
    categoryLabel: "What is this about?",
    categorySupport: "Report a problem — support request",
    categoryFeedback: "Feedback & wishes about the platform",
    categorySupportShort: "Support",
    categoryFeedbackShort: "Feedback",
    categoryHintSupport:
      "Our team helps you with problems around reviews, deletion cases or your account.",
    categoryHintFeedback:
      "Have an idea or a wish for ReviewLytics? We appreciate every piece of feedback!",
    subjectPlaceholderFeedback: "e.g. Wish: export reviews as PDF",
    messagePlaceholderFeedback:
      "Describe your idea or wish — what would make your work easier?",
    submitFeedback: "Send feedback",
    feedbackSubmitted: "Feedback sent — thank you!",
  },
  adminSupport: {
    filterAllTypes: "All types",
  },
  account: {
    enterprise: "Enterprise",
  },
  nav: {
    team: "Team",
  },
  team: {
    eyebrow: "Account access",
    title: "Team",
    subtitle:
      "Create additional logins for your team. Team members see every connected location, review and deletion case of your account.",
    addMember: "Add member",
    addTitle: "New team member",
    addHint:
      "Set a name, email address and password. The member signs in with those and sees the same data as you — billing and team management stay with you.",
    fieldName: "Name",
    fieldNamePlaceholder: "e.g. Sabine Schmidt",
    fieldEmail: "Email address",
    fieldEmailPlaceholder: "name@your-practice.com",
    fieldPassword: "Password",
    fieldPasswordPlaceholder: "At least 8 characters",
    togglePassword: "Show password",
    createCta: "Create login",
    creating: "Creating…",
    created: "Team member created.",
    passwordShareHint:
      "Share the password personally — the member can change it later in their settings.",
    membersTitle: "Logins",
    memberCount: "{{count}} people",
    ownerBadge: "Owner",
    memberBadge: "Member",
    joinedOn: "since {{date}}",
    remove: "Remove",
    removing: "Removing…",
    removeTitle: "Remove team member?",
    removeConfirm:
      "{{name}} will immediately lose access to this account. This cannot be undone.",
    keepMember: "Keep member",
    removed: "{{name}} was removed.",
    empty: "No additional logins yet.",
    memberViewNote:
      "You are signed in as a team member. Logins and billing are managed by the account owner.",
    loadError: "Team could not be loaded.",
    errorMissing: "Please fill in name, email and password.",
    errorEmailTaken: "This email address is already in use.",
    errorWeakPassword: "The password is too weak.",
    errorCreate: "Login could not be created.",
    errorRemove: "Member could not be removed.",
  },
  customOffer: {
    eyebrow: "Your custom package",
    ribbon: "Personalised",
    status: {
      draft: "Draft",
      active: "Published",
      paid: "Active",
      expired: "Expired",
      disabled: "Withdrawn",
      replaced: "Replaced",
      canceled: "Canceled",
    },
    interval: { monthly: "per month", yearly: "per year", one_time: "one-time" },
    intervalShort: { monthly: "/month", yearly: "/year", one_time: " one-time" },
    reference: "Offer no.",
    validUntil: "Offer valid until {{date}}",
    subscribe: "Subscribe now",
    payOnce: "Pay now",
    redirecting: "Redirecting to secure checkout…",
    currentPlan: "Current plan",
    activeSince: "Active since {{date}}",
    ownerOnly: "Only the account owner can purchase this package.",
    unavailable: "This offer is currently not available.",
    paymentsUnavailable: "Payments are temporarily unavailable. Please try again later.",
    checkoutError: "Checkout could not be started. Please try again.",
    stripeNote: "Secure payment via Stripe",
    cancelAnytime: "cancel any time",
    checkoutCancelled: "Checkout was cancelled — your package is still available below.",
    supportSubject: "Request: personalised custom package",
    supportMessage:
      "Hello,\n\nI'm interested in a custom package. My requirements:\n- Locations / platforms: \n- Expected deletions per month: \n- Other wishes: \n\nThank you!",
  },
  adminOffers: {
    navTitle: "Custom Offers",
    eyebrow: "Sales",
    title: "Custom offers",
    subtitle: "Personalised, directly purchasable packages per customer — create, publish, update and track.",
    newOffer: "New offer",
    stats: {
      live: "Published offers",
      paid: "Paid packages",
      withOffer: "Customers with offer",
      withoutOffer: "Customers without offer",
    },
    tabOffers: "Offers",
    tabCustomers: "Customers",
    filterAll: "All",
    filterCurrent: "Live",
    searchOffers: "Search reference, title, customer…",
    searchCustomers: "Search name, email, company…",
    hasOfferAll: "All customers",
    hasOfferYes: "With offer",
    hasOfferNo: "Without offer",
    colCustomer: "Customer",
    colPlan: "Plan",
    colCurrentOffer: "Current offer",
    colActions: "Actions",
    colValidity: "Valid until",
    colUpdated: "Updated",
    noOffers: "No offers yet.",
    noCustomers: "No customers found.",
    noOffer: "No offer",
    createFor: "Create offer",
    openOffer: "Open offer",
    openCustomer: "Open customer",
    edit: "Edit",
    activate: "Publish",
    deactivate: "Withdraw",
    delete: "Delete",
    confirmDelete: "Delete this offer?",
    yes: "Yes",
    no: "No",
    locked: "Paid — locked",
    loadError: "Could not load offers.",
    version: "v{{version}}",
    createdBy: "Created by {{name}}",
    notes: "Internal notes",
    sentOn: "Published on {{date}}",
    paidOn: "Paid on {{date}} · customer is on the Enterprise plan",
    canceledOn: "Canceled on {{date}}",
    activated: "{{reference}} is now published — the customer has been notified.",
    deactivated: "{{reference}} withdrawn.",
    deleted: "{{reference}} deleted.",
    saved: "{{reference}} saved.",
    created: "{{reference}} created as draft.",
    createdAndSent: "{{reference}} created and published to the customer.",
    editor: {
      createTitle: "New custom offer",
      editTitle: "Edit offer {{reference}}",
      customer: "Customer",
      customerSearch: "Search customer by name, email or company…",
      customerHint: "Only client account owners can receive an offer. Team members see their owner's package.",
      change: "Change",
      title: "Package name",
      titlePlaceholder: "e.g. 5 location package",
      description: "Description",
      descriptionPlaceholder: "What this package is for and what makes it special…",
      price: "Price (EUR)",
      interval: "Billing",
      features: "Included features",
      featurePlaceholder: "e.g. Unlimited locations per platform",
      included: "Toggle included / not included",
      addFeature: "Add feature",
      limits: "Terms & limits",
      limitLabel: "Label (e.g. Deletions / month)",
      limitValue: "Value",
      addLimit: "Add limit",
      validUntil: "Valid until (optional)",
      notes: "Internal notes (never shown to the customer)",
      activateNow: "Publish immediately",
      activateHint:
        "The customer is notified by email and sees the package on their Plans & Billing page, ready to purchase via Stripe. Any existing published offer for this customer is replaced.",
      save: "Save changes",
      create: "Save as draft",
      createAndSend: "Create & publish",
      saving: "Saving…",
      cancel: "Cancel",
      errorCustomer: "Please select a customer.",
      errorTitle: "Please enter a package name (min. 3 characters).",
      errorPrice: "Please enter a valid price.",
    },
    userCard: {
      title: "Custom offer",
      none: "No personalised package yet.",
      createCta: "Create offer",
      manageCta: "Manage offer",
    },
  },
  platforms: {
    locationPicker: {
      title: "Choose locations",
      subtitle: "This email account ({{email}}) has the following associated locations:",
      manageMenu: "Manage locations",
      planHintTrial:
        "Trial: connect as many locations as you like — one, several, or all.",
      planHintBasic:
        "Your Basic plan allows one connected location per platform. Choose the location to connect — you can switch to another one at any time.",
      planHintPremium:
        "Your Premium plan allows one connected location per platform. Choose the location to connect — you can switch to another one at any time.",
      planHintEnterprise:
        "Enterprise: connect as many locations as you like — one, several, or all.",
      oneAvailable: "1 location available",
      countAvailable: "{{count}} locations available",
      selectAll: "Select all",
      deselectAll: "Deselect all",
      connectedBadge: "Connected",
      reviewsMeta: "{{count}} reviews",
      selectedCount: "{{count}} selected",
      noneSelected: "No location selected",
      confirmOne: "Connect location",
      confirmMany: "Connect {{count}} locations",
      saving: "Connecting…",
      empty: "No locations found",
      emptyHint:
        "No business locations were found for this Google account. Check that your Google Business Profile is managed with this email address.",
      loadError: "Locations could not be loaded.",
      retry: "Try again",
      saveError: "Selection could not be saved.",
      limitReached:
        "Your plan allows one connected profile per platform. To connect additional profiles or locations, please contact Support about our Enterprise or Custom plan.",
      notCompleted:
        "Google is connected, but no location has been selected yet. Open the location picker to finish the connection.",
      upsellTitle: "Need more than one location?",
      upsellBody:
        "Your plan allows one connected profile per platform. To connect additional profiles or locations, please contact Support about our Enterprise or Custom plan.",
      upsellCta: "Contact Support",
      enterpriseRequestSubject: "Request: additional profiles (Enterprise / Custom plan)",
      enterpriseRequestMessage:
        "Hello,\n\nI would like to connect more than one location ({{count}} locations in my Google account in total) and I am interested in the Enterprise or Custom plan.\n\nPlease send me an offer with the terms.\n\nThank you!",
    },
    limit: {
      message:
        "Your plan allows one connected profile per platform. To connect additional profiles or locations, please contact Support about our Enterprise or Custom plan.",
      eyebrow: "Plan limit",
      title: "One profile per platform",
      slotUsed: "{{used}} of {{limit}} profile slot used",
      contactSupport: "Contact Support",
      manageCurrent: "Switch connected location",
      badge: "Limit",
      keepThis: "Keep this location",
      overLimitTitle: "Please choose the profile to keep",
      overLimitBody:
        "{{count}} {{platform}} profiles are connected, but your plan allows {{limit}}. Pick one — the others stay saved and can be reconnected later.",
      overLimitCta: "Choose profile",
      overLimitJamedaHint:
        "Disconnect the extra Jameda profiles via the menu (⋮) of each entry.",
      overLimitPickerHint:
        "More locations are connected than your plan allows. Choose the one that should stay connected — the others stay saved.",
      sidebarTitle: "Your plan",
      sidebarBody: "1 connected profile per platform",
      sidebarCta: "Need more profiles? Contact Support",
      jamedaTryAnother: "Use a different Business ID",
      supportSubject: "Request: additional profiles (Enterprise / Custom plan)",
      supportMessage:
        "Hello,\n\nI would like to connect more than one {{platform}} profile/location and I am interested in the Enterprise or Custom plan.\n\nPlease send me an offer.\n\nThank you!",
    },
  },
};

export default enExt;
